import React from 'react';

import { StyledButton } from './styles';

const Button = ({ fill = true, children, ...props }: any) => {
  return (
    <StyledButton {...props} filled={fill as boolean} >{children}</StyledButton>
  );
};

export default Button;